const modalOpen = document.querySelector('.modal-open');
const modalContainer = document.querySelector('.modal-container');
const modalClose = document.querySelector('.modal-close');
const modalVideo = document.querySelector('.modal-video');

if (modalOpen) {
  modalOpen.addEventListener('click', () => {
    if (modalContainer) {
      modalContainer.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }
  });
}

if (modalClose) {
  modalClose.addEventListener('click', () => {
    if (modalContainer) {
      modalContainer.style.display = 'none';
      document.body.style.overflow = 'auto';
    }
    if (modalVideo) {
      modalVideo.currentTime = 0;
      modalVideo.pause();
    }
  });
}

if (modalContainer) {
  modalContainer.addEventListener('click', (event) => {
    if (event.target !== modalVideo && event.target === modalContainer) {
      modalContainer.style.display = 'none';
      document.body.style.overflow = 'auto';
    }
    if (event.target !== modalVideo && modalVideo) {
      modalVideo.currentTime = 0;
      modalVideo.pause();
    }
  });
}
